var HgShare = function() {
  var options = {
    url: window.location.origin,
  };

  function fbShare() {
    var base_url = options.url + '/giveahoot/' + window.location.hash;
    var url =
      'https://www.facebook.com/sharer/sharer.php?u=' +
      encodeURIComponent(base_url);
    return url;
  }

  function twShare() {
    var base_url = options.url + '/giveahoot/' + window.location.hash;
    var url =
      'https://twitter.com/intent/tweet?' +
      'url=' +
      encodeURIComponent(base_url) +
      '&text=' +
      encodeURIComponent(
        'Support your Hooters Girls in the fight against breast cancer! #GiveAHoot'
      ) +
      '&source=webclient';
    return url;
  }

  function openModal(url) {
    var h = 250;
    var w = 626;
    var wLeft = window.screenLeft ? window.screenLeft : window.screenX;
    var wTop = window.screenTop ? window.screenTop : window.screenY;

    var left = wLeft + window.innerWidth / 2 - w / 2;
    var top = wTop + window.innerHeight / 2 - h / 2;
    window.open(
      url,
      'Share',
      'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' +
        w +
        ', height=' +
        h +
        ', top=' +
        top +
        ', left=' +
        left
    );
  }

  function init() {
    $('body').on('click', 'a.facebook, a.twitter', function(e) {
      e.preventDefault();
      e.stopPropagation();

      var url = fbShare();
      var network = 'Facebook';

      if ($(this).hasClass('twitter')) {
        url = twShare();
        network = 'Twitter';
      }

      openModal(url);
    });
  }

  init();
};
